export default {
  newsDetail: 'NEWS_DETAILS'
};
